/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { dateOnlyToQuery } from './DateOnly';
import type {
  AmsBookingResponse,
  AssetDependantsResponse,
  AssetExpensePartnerResponse,
  AssetExpensesTabResponse,
  AssetIncomeTabResponse,
  AssetInventoryCompletenessResponse,
  AssetOwnClaimsTabResponse,
  AssetPersonalDataResponse,
  AssetsTabResponse,
  AssignCounselorRequest,
  ClientDetailResponse,
  ClientOverviewResponse,
  ClientPersonalDataResponse,
  ClientResponse,
  ClientStatusCounselorResponse,
  CreateCallbackAmbulanzRequest,
  CreateCallbackRequest,
  CreateCallbackResponse,
  CreateClientRequest,
  DebtResponse,
  DonationsTabResponse,
  GoalResponse,
  LastOpenedClientResponse,
  ProblemDetails,
  PropertyRightsTabResponse,
  SaveAssetDependantsRequest,
  SaveAssetExpensesRequest,
  SaveAssetIncomeRequest,
  SaveAssetOwnClaimsRequest,
  SaveAssetPersonalDataRequest,
  SaveAssetsRequest,
  SaveDonationsRequest,
  SavePropertyRightsRequest,
  SearchResultsOfClientSearchResult,
  UpdateClientDebtsRequest,
  UpdateClientGoalsRequest,
  UpdateClientOverviewRequest,
  UpdateClientPersonalDataRequest,
  UpdateClientRequest,
  UpdateClientStatusCounselorRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    AmsBookingResponseFromJSON,
    AmsBookingResponseToJSON,
    AssetDependantsResponseFromJSON,
    AssetDependantsResponseToJSON,
    AssetExpensePartnerResponseFromJSON,
    AssetExpensePartnerResponseToJSON,
    AssetExpensesTabResponseFromJSON,
    AssetExpensesTabResponseToJSON,
    AssetIncomeTabResponseFromJSON,
    AssetIncomeTabResponseToJSON,
    AssetInventoryCompletenessResponseFromJSON,
    AssetInventoryCompletenessResponseToJSON,
    AssetOwnClaimsTabResponseFromJSON,
    AssetOwnClaimsTabResponseToJSON,
    AssetPersonalDataResponseFromJSON,
    AssetPersonalDataResponseToJSON,
    AssetsTabResponseFromJSON,
    AssetsTabResponseToJSON,
    AssignCounselorRequestFromJSON,
    AssignCounselorRequestToJSON,
    ClientDetailResponseFromJSON,
    ClientDetailResponseToJSON,
    ClientOverviewResponseFromJSON,
    ClientOverviewResponseToJSON,
    ClientPersonalDataResponseFromJSON,
    ClientPersonalDataResponseToJSON,
    ClientResponseFromJSON,
    ClientResponseToJSON,
    ClientStatusCounselorResponseFromJSON,
    ClientStatusCounselorResponseToJSON,
    CreateCallbackAmbulanzRequestFromJSON,
    CreateCallbackAmbulanzRequestToJSON,
    CreateCallbackRequestFromJSON,
    CreateCallbackRequestToJSON,
    CreateCallbackResponseFromJSON,
    CreateCallbackResponseToJSON,
    CreateClientRequestFromJSON,
    CreateClientRequestToJSON,
    DebtResponseFromJSON,
    DebtResponseToJSON,
    DonationsTabResponseFromJSON,
    DonationsTabResponseToJSON,
    GoalResponseFromJSON,
    GoalResponseToJSON,
    LastOpenedClientResponseFromJSON,
    LastOpenedClientResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PropertyRightsTabResponseFromJSON,
    PropertyRightsTabResponseToJSON,
    SaveAssetDependantsRequestFromJSON,
    SaveAssetDependantsRequestToJSON,
    SaveAssetExpensesRequestFromJSON,
    SaveAssetExpensesRequestToJSON,
    SaveAssetIncomeRequestFromJSON,
    SaveAssetIncomeRequestToJSON,
    SaveAssetOwnClaimsRequestFromJSON,
    SaveAssetOwnClaimsRequestToJSON,
    SaveAssetPersonalDataRequestFromJSON,
    SaveAssetPersonalDataRequestToJSON,
    SaveAssetsRequestFromJSON,
    SaveAssetsRequestToJSON,
    SaveDonationsRequestFromJSON,
    SaveDonationsRequestToJSON,
    SavePropertyRightsRequestFromJSON,
    SavePropertyRightsRequestToJSON,
    SearchResultsOfClientSearchResultFromJSON,
    SearchResultsOfClientSearchResultToJSON,
    UpdateClientDebtsRequestFromJSON,
    UpdateClientDebtsRequestToJSON,
    UpdateClientGoalsRequestFromJSON,
    UpdateClientGoalsRequestToJSON,
    UpdateClientOverviewRequestFromJSON,
    UpdateClientOverviewRequestToJSON,
    UpdateClientPersonalDataRequestFromJSON,
    UpdateClientPersonalDataRequestToJSON,
    UpdateClientRequestFromJSON,
    UpdateClientRequestToJSON,
    UpdateClientStatusCounselorRequestFromJSON,
    UpdateClientStatusCounselorRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface AssignCounselorToClientRequest {
    clientId: string;
    assignCounselorRequest: AssignCounselorRequest;
}

export interface CheckClientDuplicatesRequest {
    firstName?: string;
    lastName?: string;
    birthday?: Date;
}

export interface CreateAmsBookingRequest {
    clientId: string;
}

export interface CreateCallbackOperationRequest {
    clientId: string;
    createCallbackRequest: CreateCallbackRequest;
}

export interface CreateCallbackAmbulanzOperationRequest {
    clientId: string;
    createCallbackAmbulanzRequest: CreateCallbackAmbulanzRequest;
}

export interface CreateClientOperationRequest {
    createClientRequest: CreateClientRequest;
}

export interface GetAssetInventoryAssetsRequest {
    clientId: string;
}

export interface GetAssetInventoryCompletenessRequest {
    clientId: string;
}

export interface GetAssetInventoryDependantsRequest {
    clientId: string;
}

export interface GetAssetInventoryDonationsRequest {
    clientId: string;
}

export interface GetAssetInventoryExpensePartnerRequest {
    clientId: string;
    caseNumber?: string;
}

export interface GetAssetInventoryExpensesRequest {
    clientId: string;
}

export interface GetAssetInventoryIncomeRequest {
    clientId: string;
}

export interface GetAssetInventoryOwnClaimsRequest {
    clientId: string;
}

export interface GetAssetInventoryPropertyRightsRequest {
    clientId: string;
}

export interface GetClientAssetPersonalDataRequest {
    clientId: string;
}

export interface GetClientByIdRequest {
    clientId: string;
}

export interface GetClientOverviewRequest {
    clientId: string;
}

export interface GetClientPersonalDataRequest {
    clientId: string;
}

export interface GetClientStatusCounselorRequest {
    clientId: string;
}

export interface GetGoalsResultsByClientIdRequest {
    clientId: string;
}

export interface GetMeasuresCausesByClientIdRequest {
    clientId: string;
}

export interface SaveAssetInventoryAssetsRequest {
    clientId: string;
    saveAssetsRequest: SaveAssetsRequest;
}

export interface SaveAssetInventoryDependantsRequest {
    clientId: string;
    saveAssetDependantsRequest: SaveAssetDependantsRequest;
}

export interface SaveAssetInventoryDonationsRequest {
    clientId: string;
    saveDonationsRequest: SaveDonationsRequest;
}

export interface SaveAssetInventoryExpensesRequest {
    clientId: string;
    saveAssetExpensesRequest: SaveAssetExpensesRequest;
}

export interface SaveAssetInventoryIncomeRequest {
    clientId: string;
    saveAssetIncomeRequest: SaveAssetIncomeRequest;
}

export interface SaveAssetInventoryOwnClaimsRequest {
    clientId: string;
    saveAssetOwnClaimsRequest: SaveAssetOwnClaimsRequest;
}

export interface SaveAssetInventoryPropertyRightsRequest {
    clientId: string;
    savePropertyRightsRequest: SavePropertyRightsRequest;
}

export interface SaveClientAssetPersonalDataRequest {
    clientId: string;
    saveAssetPersonalDataRequest: SaveAssetPersonalDataRequest;
}

export interface SearchClientsRequest {
    searchText?: string;
    extendedSearchSalutation?: string;
    extendedSearchTitle?: string;
    extendedSearchName?: string;
    extendedSearchBirthday?: Date;
    extendedSearchInsuranceNumber?: string;
    extendedSearchCaseNumber?: string;
    extendedSearchSrvFileNumber?: string;
    extendedSearchCourtId?: string;
    extendedSearchStreet?: string;
    extendedSearchZipCode?: string;
    extendedSearchCity?: string;
    extendedSearchNationality?: string;
    extendedSearchMediaInquiry?: string;
    extendedSearchCaseNoteDateFrom?: Date;
    extendedSearchCaseNoteDateTo?: Date;
    extendedSearchCaseNoteKeyword?: string;
    extendedSearchAssignedCounselorId?: string;
    extendedSearchStatus?: string;
}

export interface ShareAssetInventoryExpensesWithPartnerRequest {
    clientId: string;
    partnerClientId: string;
}

export interface UpdateClientOperationRequest {
    clientId: string;
    updateClientRequest: UpdateClientRequest;
}

export interface UpdateClientGoalsResultsRequest {
    clientId: string;
    updateClientGoalsRequest: UpdateClientGoalsRequest;
}

export interface UpdateClientMeasuresCausesRequest {
    clientId: string;
    updateClientDebtsRequest: UpdateClientDebtsRequest;
}

export interface UpdateClientOverviewOperationRequest {
    clientId: string;
    updateClientOverviewRequest: UpdateClientOverviewRequest;
}

export interface UpdateClientPersonalDataOperationRequest {
    clientId: string;
    updateClientPersonalDataRequest: UpdateClientPersonalDataRequest;
}

export interface UpdateClientStatusCounselorOperationRequest {
    clientId: string;
    updateClientStatusCounselorRequest: UpdateClientStatusCounselorRequest;
}

/**
 * ClientsApi - interface
 * 
 * @export
 * @interface ClientsApiInterface
 */
export interface ClientsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {AssignCounselorRequest} assignCounselorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    assignCounselorToClientRaw(requestParameters: AssignCounselorToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientDetailResponse>>;

    /**
     */
    assignCounselorToClient(requestParameters: AssignCounselorToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientDetailResponse>;

    /**
     * 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {Date} [birthday] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    checkClientDuplicatesRaw(requestParameters: CheckClientDuplicatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfClientSearchResult>>;

    /**
     */
    checkClientDuplicates(requestParameters: CheckClientDuplicatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfClientSearchResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    createAmsBookingRaw(requestParameters: CreateAmsBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmsBookingResponse>>;

    /**
     */
    createAmsBooking(requestParameters: CreateAmsBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmsBookingResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {CreateCallbackRequest} createCallbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    createCallbackRaw(requestParameters: CreateCallbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCallbackResponse>>;

    /**
     */
    createCallback(requestParameters: CreateCallbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCallbackResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {CreateCallbackAmbulanzRequest} createCallbackAmbulanzRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    createCallbackAmbulanzRaw(requestParameters: CreateCallbackAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    createCallbackAmbulanz(requestParameters: CreateCallbackAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {CreateClientRequest} createClientRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    createClientRaw(requestParameters: CreateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientResponse>>;

    /**
     */
    createClient(requestParameters: CreateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryAssetsRaw(requestParameters: GetAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetsTabResponse>>;

    /**
     */
    getAssetInventoryAssets(requestParameters: GetAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryCompletenessRaw(requestParameters: GetAssetInventoryCompletenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryCompletenessResponse>>;

    /**
     */
    getAssetInventoryCompleteness(requestParameters: GetAssetInventoryCompletenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryCompletenessResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryDependantsRaw(requestParameters: GetAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDependantsResponse>>;

    /**
     */
    getAssetInventoryDependants(requestParameters: GetAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDependantsResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryDonationsRaw(requestParameters: GetAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationsTabResponse>>;

    /**
     */
    getAssetInventoryDonations(requestParameters: GetAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} [caseNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryExpensePartnerRaw(requestParameters: GetAssetInventoryExpensePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetExpensePartnerResponse>>;

    /**
     */
    getAssetInventoryExpensePartner(requestParameters: GetAssetInventoryExpensePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetExpensePartnerResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryExpensesRaw(requestParameters: GetAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetExpensesTabResponse>>;

    /**
     */
    getAssetInventoryExpenses(requestParameters: GetAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetExpensesTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryIncomeRaw(requestParameters: GetAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetIncomeTabResponse>>;

    /**
     */
    getAssetInventoryIncome(requestParameters: GetAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetIncomeTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryOwnClaimsRaw(requestParameters: GetAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetOwnClaimsTabResponse>>;

    /**
     */
    getAssetInventoryOwnClaims(requestParameters: GetAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetOwnClaimsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getAssetInventoryPropertyRightsRaw(requestParameters: GetAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyRightsTabResponse>>;

    /**
     */
    getAssetInventoryPropertyRights(requestParameters: GetAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyRightsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getClientAssetPersonalDataRaw(requestParameters: GetClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetPersonalDataResponse>>;

    /**
     */
    getClientAssetPersonalData(requestParameters: GetClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetPersonalDataResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getClientByIdRaw(requestParameters: GetClientByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientDetailResponse>>;

    /**
     */
    getClientById(requestParameters: GetClientByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientDetailResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getClientOverviewRaw(requestParameters: GetClientOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientOverviewResponse>>;

    /**
     */
    getClientOverview(requestParameters: GetClientOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientOverviewResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getClientPersonalDataRaw(requestParameters: GetClientPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientPersonalDataResponse>>;

    /**
     */
    getClientPersonalData(requestParameters: GetClientPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientPersonalDataResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getClientStatusCounselorRaw(requestParameters: GetClientStatusCounselorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientStatusCounselorResponse>>;

    /**
     */
    getClientStatusCounselor(requestParameters: GetClientStatusCounselorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientStatusCounselorResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getGoalsResultsByClientIdRaw(requestParameters: GetGoalsResultsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoalResponse>>>;

    /**
     */
    getGoalsResultsByClientId(requestParameters: GetGoalsResultsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoalResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getLastOpenedClientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LastOpenedClientResponse>>>;

    /**
     */
    getLastOpenedClients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LastOpenedClientResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    getMeasuresCausesByClientIdRaw(requestParameters: GetMeasuresCausesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DebtResponse>>>;

    /**
     */
    getMeasuresCausesByClientId(requestParameters: GetMeasuresCausesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DebtResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveAssetsRequest} saveAssetsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryAssetsRaw(requestParameters: SaveAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetsTabResponse>>;

    /**
     */
    saveAssetInventoryAssets(requestParameters: SaveAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveAssetDependantsRequest} saveAssetDependantsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryDependantsRaw(requestParameters: SaveAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDependantsResponse>>;

    /**
     */
    saveAssetInventoryDependants(requestParameters: SaveAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDependantsResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveDonationsRequest} saveDonationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryDonationsRaw(requestParameters: SaveAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationsTabResponse>>;

    /**
     */
    saveAssetInventoryDonations(requestParameters: SaveAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveAssetExpensesRequest} saveAssetExpensesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryExpensesRaw(requestParameters: SaveAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetExpensesTabResponse>>;

    /**
     */
    saveAssetInventoryExpenses(requestParameters: SaveAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetExpensesTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveAssetIncomeRequest} saveAssetIncomeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryIncomeRaw(requestParameters: SaveAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetIncomeTabResponse>>;

    /**
     */
    saveAssetInventoryIncome(requestParameters: SaveAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetIncomeTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveAssetOwnClaimsRequest} saveAssetOwnClaimsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryOwnClaimsRaw(requestParameters: SaveAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetOwnClaimsTabResponse>>;

    /**
     */
    saveAssetInventoryOwnClaims(requestParameters: SaveAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetOwnClaimsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SavePropertyRightsRequest} savePropertyRightsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveAssetInventoryPropertyRightsRaw(requestParameters: SaveAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyRightsTabResponse>>;

    /**
     */
    saveAssetInventoryPropertyRights(requestParameters: SaveAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyRightsTabResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveAssetPersonalDataRequest} saveAssetPersonalDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    saveClientAssetPersonalDataRaw(requestParameters: SaveClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetPersonalDataResponse>>;

    /**
     */
    saveClientAssetPersonalData(requestParameters: SaveClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetPersonalDataResponse>;

    /**
     * 
     * @param {string} [searchText] 
     * @param {string} [extendedSearchSalutation] 
     * @param {string} [extendedSearchTitle] 
     * @param {string} [extendedSearchName] 
     * @param {Date} [extendedSearchBirthday] 
     * @param {string} [extendedSearchInsuranceNumber] 
     * @param {string} [extendedSearchCaseNumber] 
     * @param {string} [extendedSearchSrvFileNumber] 
     * @param {string} [extendedSearchCourtId] 
     * @param {string} [extendedSearchStreet] 
     * @param {string} [extendedSearchZipCode] 
     * @param {string} [extendedSearchCity] 
     * @param {string} [extendedSearchNationality] 
     * @param {string} [extendedSearchMediaInquiry] 
     * @param {Date} [extendedSearchCaseNoteDateFrom] 
     * @param {Date} [extendedSearchCaseNoteDateTo] 
     * @param {string} [extendedSearchCaseNoteKeyword] 
     * @param {string} [extendedSearchAssignedCounselorId] 
     * @param {string} [extendedSearchStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    searchClientsRaw(requestParameters: SearchClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfClientSearchResult>>;

    /**
     */
    searchClients(requestParameters: SearchClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfClientSearchResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} partnerClientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    shareAssetInventoryExpensesWithPartnerRaw(requestParameters: ShareAssetInventoryExpensesWithPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    shareAssetInventoryExpensesWithPartner(requestParameters: ShareAssetInventoryExpensesWithPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientRequest} updateClientRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    updateClientRaw(requestParameters: UpdateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientDetailResponse>>;

    /**
     */
    updateClient(requestParameters: UpdateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientDetailResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientGoalsRequest} updateClientGoalsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    updateClientGoalsResultsRaw(requestParameters: UpdateClientGoalsResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoalResponse>>>;

    /**
     */
    updateClientGoalsResults(requestParameters: UpdateClientGoalsResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoalResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientDebtsRequest} updateClientDebtsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    updateClientMeasuresCausesRaw(requestParameters: UpdateClientMeasuresCausesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DebtResponse>>>;

    /**
     */
    updateClientMeasuresCauses(requestParameters: UpdateClientMeasuresCausesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DebtResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientOverviewRequest} updateClientOverviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    updateClientOverviewRaw(requestParameters: UpdateClientOverviewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientOverviewResponse>>;

    /**
     */
    updateClientOverview(requestParameters: UpdateClientOverviewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientOverviewResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientPersonalDataRequest} updateClientPersonalDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    updateClientPersonalDataRaw(requestParameters: UpdateClientPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientPersonalDataResponse>>;

    /**
     */
    updateClientPersonalData(requestParameters: UpdateClientPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientPersonalDataResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientStatusCounselorRequest} updateClientStatusCounselorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApiInterface
     */
    updateClientStatusCounselorRaw(requestParameters: UpdateClientStatusCounselorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientStatusCounselorResponse>>;

    /**
     */
    updateClientStatusCounselor(requestParameters: UpdateClientStatusCounselorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientStatusCounselorResponse>;

}

/**
 * 
 */
export class ClientsApi extends runtime.BaseAPI implements ClientsApiInterface {

    /**
     */
    async assignCounselorToClientRaw(requestParameters: AssignCounselorToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientDetailResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling assignCounselorToClient().'
            );
        }

        if (requestParameters['assignCounselorRequest'] == null) {
            throw new runtime.RequiredError(
                'assignCounselorRequest',
                'Required parameter "assignCounselorRequest" was null or undefined when calling assignCounselorToClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/counselor`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AssignCounselorRequestToJSON(requestParameters['assignCounselorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async assignCounselorToClient(requestParameters: AssignCounselorToClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientDetailResponse> {
        const response = await this.assignCounselorToClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async checkClientDuplicatesRaw(requestParameters: CheckClientDuplicatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfClientSearchResult>> {
        const queryParameters: any = {};

        if (requestParameters['firstName'] != null) {
            queryParameters['firstName'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['lastName'] = requestParameters['lastName'];
        }

        if (requestParameters['birthday'] != null) {
            queryParameters['birthday'] = dateOnlyToQuery(requestParameters['birthday'] as Date);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/duplicate-check`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsOfClientSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async checkClientDuplicates(requestParameters: CheckClientDuplicatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfClientSearchResult> {
        const response = await this.checkClientDuplicatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createAmsBookingRaw(requestParameters: CreateAmsBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmsBookingResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createAmsBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/ams-booking`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmsBookingResponseFromJSON(jsonValue));
    }

    /**
     */
    async createAmsBooking(requestParameters: CreateAmsBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmsBookingResponse> {
        const response = await this.createAmsBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCallbackRaw(requestParameters: CreateCallbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCallbackResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createCallback().'
            );
        }

        if (requestParameters['createCallbackRequest'] == null) {
            throw new runtime.RequiredError(
                'createCallbackRequest',
                'Required parameter "createCallbackRequest" was null or undefined when calling createCallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/callback`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCallbackRequestToJSON(requestParameters['createCallbackRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCallbackResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCallback(requestParameters: CreateCallbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCallbackResponse> {
        const response = await this.createCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCallbackAmbulanzRaw(requestParameters: CreateCallbackAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createCallbackAmbulanz().'
            );
        }

        if (requestParameters['createCallbackAmbulanzRequest'] == null) {
            throw new runtime.RequiredError(
                'createCallbackAmbulanzRequest',
                'Required parameter "createCallbackAmbulanzRequest" was null or undefined when calling createCallbackAmbulanz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/callback-ambulanz`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCallbackAmbulanzRequestToJSON(requestParameters['createCallbackAmbulanzRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createCallbackAmbulanz(requestParameters: CreateCallbackAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCallbackAmbulanzRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createClientRaw(requestParameters: CreateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientResponse>> {
        if (requestParameters['createClientRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientRequest',
                'Required parameter "createClientRequest" was null or undefined when calling createClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientRequestToJSON(requestParameters['createClientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientResponseFromJSON(jsonValue));
    }

    /**
     */
    async createClient(requestParameters: CreateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientResponse> {
        const response = await this.createClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryAssetsRaw(requestParameters: GetAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryAssets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/assets`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryAssets(requestParameters: GetAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetsTabResponse> {
        const response = await this.getAssetInventoryAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryCompletenessRaw(requestParameters: GetAssetInventoryCompletenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryCompletenessResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryCompleteness().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/completeness`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryCompletenessResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryCompleteness(requestParameters: GetAssetInventoryCompletenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryCompletenessResponse> {
        const response = await this.getAssetInventoryCompletenessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryDependantsRaw(requestParameters: GetAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDependantsResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryDependants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/dependants`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetDependantsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryDependants(requestParameters: GetAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDependantsResponse> {
        const response = await this.getAssetInventoryDependantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryDonationsRaw(requestParameters: GetAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryDonations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/donations`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DonationsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryDonations(requestParameters: GetAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationsTabResponse> {
        const response = await this.getAssetInventoryDonationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryExpensePartnerRaw(requestParameters: GetAssetInventoryExpensePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetExpensePartnerResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryExpensePartner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['caseNumber'] != null) {
            queryParameters['caseNumber'] = requestParameters['caseNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/expenses/partner`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetExpensePartnerResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryExpensePartner(requestParameters: GetAssetInventoryExpensePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetExpensePartnerResponse> {
        const response = await this.getAssetInventoryExpensePartnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryExpensesRaw(requestParameters: GetAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetExpensesTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryExpenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/expenses`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetExpensesTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryExpenses(requestParameters: GetAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetExpensesTabResponse> {
        const response = await this.getAssetInventoryExpensesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryIncomeRaw(requestParameters: GetAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetIncomeTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryIncome().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/income`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetIncomeTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryIncome(requestParameters: GetAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetIncomeTabResponse> {
        const response = await this.getAssetInventoryIncomeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryOwnClaimsRaw(requestParameters: GetAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetOwnClaimsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryOwnClaims().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/own-claims`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetOwnClaimsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryOwnClaims(requestParameters: GetAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetOwnClaimsTabResponse> {
        const response = await this.getAssetInventoryOwnClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryPropertyRightsRaw(requestParameters: GetAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyRightsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryPropertyRights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/other-property-rights`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyRightsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetInventoryPropertyRights(requestParameters: GetAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyRightsTabResponse> {
        const response = await this.getAssetInventoryPropertyRightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientAssetPersonalDataRaw(requestParameters: GetClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetPersonalDataResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientAssetPersonalData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/personal-data`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetPersonalDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientAssetPersonalData(requestParameters: GetClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetPersonalDataResponse> {
        const response = await this.getClientAssetPersonalDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientByIdRaw(requestParameters: GetClientByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientDetailResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientById(requestParameters: GetClientByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientDetailResponse> {
        const response = await this.getClientByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientOverviewRaw(requestParameters: GetClientOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientOverviewResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/overview`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientOverviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientOverview(requestParameters: GetClientOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientOverviewResponse> {
        const response = await this.getClientOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientPersonalDataRaw(requestParameters: GetClientPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientPersonalDataResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientPersonalData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/personal-data`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientPersonalDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientPersonalData(requestParameters: GetClientPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientPersonalDataResponse> {
        const response = await this.getClientPersonalDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientStatusCounselorRaw(requestParameters: GetClientStatusCounselorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientStatusCounselorResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientStatusCounselor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/status-counselor`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientStatusCounselorResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientStatusCounselor(requestParameters: GetClientStatusCounselorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientStatusCounselorResponse> {
        const response = await this.getClientStatusCounselorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGoalsResultsByClientIdRaw(requestParameters: GetGoalsResultsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoalResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getGoalsResultsByClientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/goals-results`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoalResponseFromJSON));
    }

    /**
     */
    async getGoalsResultsByClientId(requestParameters: GetGoalsResultsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoalResponse>> {
        const response = await this.getGoalsResultsByClientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLastOpenedClientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LastOpenedClientResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/last-opened`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LastOpenedClientResponseFromJSON));
    }

    /**
     */
    async getLastOpenedClients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LastOpenedClientResponse>> {
        const response = await this.getLastOpenedClientsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMeasuresCausesByClientIdRaw(requestParameters: GetMeasuresCausesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DebtResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getMeasuresCausesByClientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/measures-causes`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DebtResponseFromJSON));
    }

    /**
     */
    async getMeasuresCausesByClientId(requestParameters: GetMeasuresCausesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DebtResponse>> {
        const response = await this.getMeasuresCausesByClientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryAssetsRaw(requestParameters: SaveAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryAssets().'
            );
        }

        if (requestParameters['saveAssetsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAssetsRequest',
                'Required parameter "saveAssetsRequest" was null or undefined when calling saveAssetInventoryAssets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/assets`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAssetsRequestToJSON(requestParameters['saveAssetsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryAssets(requestParameters: SaveAssetInventoryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetsTabResponse> {
        const response = await this.saveAssetInventoryAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryDependantsRaw(requestParameters: SaveAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDependantsResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryDependants().'
            );
        }

        if (requestParameters['saveAssetDependantsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAssetDependantsRequest',
                'Required parameter "saveAssetDependantsRequest" was null or undefined when calling saveAssetInventoryDependants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/dependants`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAssetDependantsRequestToJSON(requestParameters['saveAssetDependantsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetDependantsResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryDependants(requestParameters: SaveAssetInventoryDependantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDependantsResponse> {
        const response = await this.saveAssetInventoryDependantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryDonationsRaw(requestParameters: SaveAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryDonations().'
            );
        }

        if (requestParameters['saveDonationsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveDonationsRequest',
                'Required parameter "saveDonationsRequest" was null or undefined when calling saveAssetInventoryDonations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/donations`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveDonationsRequestToJSON(requestParameters['saveDonationsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DonationsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryDonations(requestParameters: SaveAssetInventoryDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationsTabResponse> {
        const response = await this.saveAssetInventoryDonationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryExpensesRaw(requestParameters: SaveAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetExpensesTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryExpenses().'
            );
        }

        if (requestParameters['saveAssetExpensesRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAssetExpensesRequest',
                'Required parameter "saveAssetExpensesRequest" was null or undefined when calling saveAssetInventoryExpenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/expenses`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAssetExpensesRequestToJSON(requestParameters['saveAssetExpensesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetExpensesTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryExpenses(requestParameters: SaveAssetInventoryExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetExpensesTabResponse> {
        const response = await this.saveAssetInventoryExpensesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryIncomeRaw(requestParameters: SaveAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetIncomeTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryIncome().'
            );
        }

        if (requestParameters['saveAssetIncomeRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAssetIncomeRequest',
                'Required parameter "saveAssetIncomeRequest" was null or undefined when calling saveAssetInventoryIncome().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/income`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAssetIncomeRequestToJSON(requestParameters['saveAssetIncomeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetIncomeTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryIncome(requestParameters: SaveAssetInventoryIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetIncomeTabResponse> {
        const response = await this.saveAssetInventoryIncomeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryOwnClaimsRaw(requestParameters: SaveAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetOwnClaimsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryOwnClaims().'
            );
        }

        if (requestParameters['saveAssetOwnClaimsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAssetOwnClaimsRequest',
                'Required parameter "saveAssetOwnClaimsRequest" was null or undefined when calling saveAssetInventoryOwnClaims().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/own-claims`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAssetOwnClaimsRequestToJSON(requestParameters['saveAssetOwnClaimsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetOwnClaimsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryOwnClaims(requestParameters: SaveAssetInventoryOwnClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetOwnClaimsTabResponse> {
        const response = await this.saveAssetInventoryOwnClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAssetInventoryPropertyRightsRaw(requestParameters: SaveAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyRightsTabResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveAssetInventoryPropertyRights().'
            );
        }

        if (requestParameters['savePropertyRightsRequest'] == null) {
            throw new runtime.RequiredError(
                'savePropertyRightsRequest',
                'Required parameter "savePropertyRightsRequest" was null or undefined when calling saveAssetInventoryPropertyRights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/other-property-rights`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SavePropertyRightsRequestToJSON(requestParameters['savePropertyRightsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyRightsTabResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveAssetInventoryPropertyRights(requestParameters: SaveAssetInventoryPropertyRightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyRightsTabResponse> {
        const response = await this.saveAssetInventoryPropertyRightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveClientAssetPersonalDataRaw(requestParameters: SaveClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetPersonalDataResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveClientAssetPersonalData().'
            );
        }

        if (requestParameters['saveAssetPersonalDataRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAssetPersonalDataRequest',
                'Required parameter "saveAssetPersonalDataRequest" was null or undefined when calling saveClientAssetPersonalData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/personal-data`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAssetPersonalDataRequestToJSON(requestParameters['saveAssetPersonalDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetPersonalDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveClientAssetPersonalData(requestParameters: SaveClientAssetPersonalDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetPersonalDataResponse> {
        const response = await this.saveClientAssetPersonalDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchClientsRaw(requestParameters: SearchClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfClientSearchResult>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['SearchText'] = requestParameters['searchText'];
        }

        if (requestParameters['extendedSearchSalutation'] != null) {
            queryParameters['ExtendedSearch.Salutation'] = requestParameters['extendedSearchSalutation'];
        }

        if (requestParameters['extendedSearchTitle'] != null) {
            queryParameters['ExtendedSearch.Title'] = requestParameters['extendedSearchTitle'];
        }

        if (requestParameters['extendedSearchName'] != null) {
            queryParameters['ExtendedSearch.Name'] = requestParameters['extendedSearchName'];
        }

        if (requestParameters['extendedSearchBirthday'] != null) {
            queryParameters['ExtendedSearch.Birthday'] = dateOnlyToQuery(requestParameters['extendedSearchBirthday'] as Date);
        }

        if (requestParameters['extendedSearchInsuranceNumber'] != null) {
            queryParameters['ExtendedSearch.InsuranceNumber'] = requestParameters['extendedSearchInsuranceNumber'];
        }

        if (requestParameters['extendedSearchCaseNumber'] != null) {
            queryParameters['ExtendedSearch.CaseNumber'] = requestParameters['extendedSearchCaseNumber'];
        }

        if (requestParameters['extendedSearchSrvFileNumber'] != null) {
            queryParameters['ExtendedSearch.SrvFileNumber'] = requestParameters['extendedSearchSrvFileNumber'];
        }

        if (requestParameters['extendedSearchCourtId'] != null) {
            queryParameters['ExtendedSearch.CourtId'] = requestParameters['extendedSearchCourtId'];
        }

        if (requestParameters['extendedSearchStreet'] != null) {
            queryParameters['ExtendedSearch.Street'] = requestParameters['extendedSearchStreet'];
        }

        if (requestParameters['extendedSearchZipCode'] != null) {
            queryParameters['ExtendedSearch.ZipCode'] = requestParameters['extendedSearchZipCode'];
        }

        if (requestParameters['extendedSearchCity'] != null) {
            queryParameters['ExtendedSearch.City'] = requestParameters['extendedSearchCity'];
        }

        if (requestParameters['extendedSearchNationality'] != null) {
            queryParameters['ExtendedSearch.Nationality'] = requestParameters['extendedSearchNationality'];
        }

        if (requestParameters['extendedSearchMediaInquiry'] != null) {
            queryParameters['ExtendedSearch.MediaInquiry'] = requestParameters['extendedSearchMediaInquiry'];
        }

        if (requestParameters['extendedSearchCaseNoteDateFrom'] != null) {
            queryParameters['ExtendedSearch.CaseNote.DateFrom'] = dateOnlyToQuery(requestParameters['extendedSearchCaseNoteDateFrom'] as Date);
        }

        if (requestParameters['extendedSearchCaseNoteDateTo'] != null) {
            queryParameters['ExtendedSearch.CaseNote.DateTo'] = dateOnlyToQuery(requestParameters['extendedSearchCaseNoteDateTo'] as Date);
        }

        if (requestParameters['extendedSearchCaseNoteKeyword'] != null) {
            queryParameters['ExtendedSearch.CaseNote.Keyword'] = requestParameters['extendedSearchCaseNoteKeyword'];
        }

        if (requestParameters['extendedSearchAssignedCounselorId'] != null) {
            queryParameters['ExtendedSearch.AssignedCounselorId'] = requestParameters['extendedSearchAssignedCounselorId'];
        }

        if (requestParameters['extendedSearchStatus'] != null) {
            queryParameters['ExtendedSearch.Status'] = requestParameters['extendedSearchStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsOfClientSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async searchClients(requestParameters: SearchClientsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfClientSearchResult> {
        const response = await this.searchClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async shareAssetInventoryExpensesWithPartnerRaw(requestParameters: ShareAssetInventoryExpensesWithPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling shareAssetInventoryExpensesWithPartner().'
            );
        }

        if (requestParameters['partnerClientId'] == null) {
            throw new runtime.RequiredError(
                'partnerClientId',
                'Required parameter "partnerClientId" was null or undefined when calling shareAssetInventoryExpensesWithPartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/expenses/partner/{partnerClientId}/share`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"partnerClientId"}}`, encodeURIComponent(String(requestParameters['partnerClientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shareAssetInventoryExpensesWithPartner(requestParameters: ShareAssetInventoryExpensesWithPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shareAssetInventoryExpensesWithPartnerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateClientRaw(requestParameters: UpdateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientDetailResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClient().'
            );
        }

        if (requestParameters['updateClientRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientRequest',
                'Required parameter "updateClientRequest" was null or undefined when calling updateClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientRequestToJSON(requestParameters['updateClientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClient(requestParameters: UpdateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientDetailResponse> {
        const response = await this.updateClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientGoalsResultsRaw(requestParameters: UpdateClientGoalsResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoalResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientGoalsResults().'
            );
        }

        if (requestParameters['updateClientGoalsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientGoalsRequest',
                'Required parameter "updateClientGoalsRequest" was null or undefined when calling updateClientGoalsResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/goals-results`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientGoalsRequestToJSON(requestParameters['updateClientGoalsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoalResponseFromJSON));
    }

    /**
     */
    async updateClientGoalsResults(requestParameters: UpdateClientGoalsResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoalResponse>> {
        const response = await this.updateClientGoalsResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientMeasuresCausesRaw(requestParameters: UpdateClientMeasuresCausesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DebtResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientMeasuresCauses().'
            );
        }

        if (requestParameters['updateClientDebtsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientDebtsRequest',
                'Required parameter "updateClientDebtsRequest" was null or undefined when calling updateClientMeasuresCauses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/measures-causes`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientDebtsRequestToJSON(requestParameters['updateClientDebtsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DebtResponseFromJSON));
    }

    /**
     */
    async updateClientMeasuresCauses(requestParameters: UpdateClientMeasuresCausesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DebtResponse>> {
        const response = await this.updateClientMeasuresCausesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientOverviewRaw(requestParameters: UpdateClientOverviewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientOverviewResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientOverview().'
            );
        }

        if (requestParameters['updateClientOverviewRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientOverviewRequest',
                'Required parameter "updateClientOverviewRequest" was null or undefined when calling updateClientOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/overview`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientOverviewRequestToJSON(requestParameters['updateClientOverviewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientOverviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClientOverview(requestParameters: UpdateClientOverviewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientOverviewResponse> {
        const response = await this.updateClientOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientPersonalDataRaw(requestParameters: UpdateClientPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientPersonalDataResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientPersonalData().'
            );
        }

        if (requestParameters['updateClientPersonalDataRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientPersonalDataRequest',
                'Required parameter "updateClientPersonalDataRequest" was null or undefined when calling updateClientPersonalData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/personal-data`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientPersonalDataRequestToJSON(requestParameters['updateClientPersonalDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientPersonalDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClientPersonalData(requestParameters: UpdateClientPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientPersonalDataResponse> {
        const response = await this.updateClientPersonalDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientStatusCounselorRaw(requestParameters: UpdateClientStatusCounselorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientStatusCounselorResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientStatusCounselor().'
            );
        }

        if (requestParameters['updateClientStatusCounselorRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientStatusCounselorRequest',
                'Required parameter "updateClientStatusCounselorRequest" was null or undefined when calling updateClientStatusCounselor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/status-counselor`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientStatusCounselorRequestToJSON(requestParameters['updateClientStatusCounselorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientStatusCounselorResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClientStatusCounselor(requestParameters: UpdateClientStatusCounselorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientStatusCounselorResponse> {
        const response = await this.updateClientStatusCounselorRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
